"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const imageFlags = require("./flags.png");
const react_telephone_input_1 = require("react-telephone-input");
const phone_input_styled_1 = require("./phone-input.styled");
const formatE164 = (tel) => tel.replace(/[()-]/g, '');
exports.PhoneInput = (props) => {
    const classNames = [];
    if (props.className)
        classNames.push(props.className);
    const onChange = (value, evt) => {
        if (props.onChange) {
            const event = Object.assign({}, evt, { value: formatE164(value) });
            props.onChange(event);
        }
    };
    const rtiProps = {
        defaultCountry: 'gb',
        preferredCountries: ['gb', 'ie', 'fr', 'es', 'it', 'gr', 'us'],
        flagsImagePath: String(imageFlags),
        initialValue: props.value || '',
        classNames: classNames.join(' '),
        onChange
    };
    return React.createElement(phone_input_styled_1.StyledPhoneInput, null,
        React.createElement(react_telephone_input_1.ReactTelephoneInput, Object.assign({}, rtiProps)));
};
//# sourceMappingURL=PhoneInput.js.map